export const SUBMIT_FRANCHISE_QUERY =  'SUBMIT_FRANCHISE_QUERY';
export const SUBMIT_FEEDBACK =  'SUBMIT_FEEDBACK';
